export type Receipt = any

export interface ReceiptsState {
    loading: boolean
    loadingdata: boolean
    loadingPaymentMethods: boolean
    resultreceipt: string | null
    receipts: Receipt[]
    receiptsForSelect: Receipt[]
    receipt: Receipt | null
    paymentMethods: any[]
    total: number
    formParams: any | null
    paidReceiptIds: string[]
}

const initialState: ReceiptsState = {
    loading: false,
    loadingPaymentMethods: false,
    resultreceipt: null,
    loadingdata: false,
    receipts: [],
    receiptsForSelect: [],
    receipt: null,
    paymentMethods: [],
    total: 0,
    formParams: null,
    paidReceiptIds: []
}

export const receiptsReducer = (state: ReceiptsState = initialState, action: { type: string; payload?: any }): ReceiptsState => {
    switch (action.type) {
        case "RECEIPT_GETALL_SUCCESS":
            return {
                ...state,
                loading: false,
                receipts: action.payload.receipts as Receipt[],
                total: action.payload.total,
                resultreceipt: null,
            }

        case "RECEIPT_GETALLFORSELECT_SUCCESS":
            return {
                ...state,
                receiptsForSelect: action.payload as Receipt[],
                loading: false,
                resultreceipt: null,
            }

        case "RECEIPT_GET_SUCCESS":
            return {
                ...state,
                loading: false,
                receipt: action.payload.receipt as Receipt,
            }

        case "RECEIPT_RESET_RESULT":
            return {
                ...state,
                resultreceipt: null,
            }

        case "RECEIPT_EDIT_SUCCESS":
            return {
                ...state,
                loading: false,
                resultreceipt: action.payload.message as string
            }

        case "RECEIPT_LOADING":
            return {
                ...state,
                loading: true,
            }

        case "RECEIPT_NOT_LOADING":
            return {
                ...state,
                loading: false,
            }

        case "RECEIPTDATA_GET_SUCCESS":
            return {
                ...state,
                loadingdata: false,
                receipt: action.payload.receipt as Receipt,
            }

        case "RECEIPTDATA_LOADING":
            return {
                ...state,
                loadingdata: true,
            }

        case "RECEIPTDATA_NOT_LOADING":
            return {
                ...state,
                loadingdata: false,
            }

        case "PAYMENTMETHODS_GET_SUCCESS":
            return {
                ...state,
                loadingPaymentMethods: false,
                paymentMethods: action.payload.paymentMethods as any[],
            }

        case "PAYMENTMETHODS_IMPORT_SUCCESS":
            return {
                ...state,
                loadingPaymentMethods: false,
                paymentMethods: action.payload.paymentMethods as any[],
            }

        case "RECEIPT_VERIFY_CODE_SUCCESS":
            return {
                ...state,
                loading: false,
                receipts: action.payload.receipts as Receipt[],
            }

        case "RECEIPT_VERIFY_CODE_ERROR":
            return {
                ...state,
                loading: false,
                resultreceipt: action.payload.message
            }

        case "PAYMENTMETHODS_LOADING":
            return {
                ...state,
                loadingPaymentMethods: true,
            }

        case "PAYMENTMETHODS_NOT_LOADING":
            return {
                ...state,
                loadingPaymentMethods: false,
            }

        case "RECEIPT_GET_PAYMENT_FORM_SUCCESS":
            return {
                ...state,
                loading: false,
                formParams: action.payload,
            }

        case "RECEIPT_GET_PAYMENT_FORM_RESET":
            return {
                ...state,
                formParams: null,
            }

        case "RECEIPT_CHECK_PAID_SUCCESS":
            return {
                ...state,
                paidReceiptIds: action.payload.paidReceiptIds
            }

        default:
            return state
    }
}
